import { configureStore, Tuple } from '@reduxjs/toolkit'
import { envs } from 'application/envHandler'
import navbarReducer from 'application/header/navbar/reducers'
import carouselReducer from 'core/carousel/redux'
import I18NReducer from 'core/i18n/reducer'
import { pendingTasksReducer } from 'core/indicator/pending-tasks-redux'
import modalReducer from 'core/modal/redux'
import multipleSearchReducer from 'core/multiple-search/redux'
import paginationReducer from 'core/pagination-optimized/redux'
import searchReducer from 'core/search/redux'
import sideMenuReducer from 'core/side-menu/redux'
import sidebarReducer from 'core/sidebar/redux'
import spinnerReducer from 'core/spinner/redux'
import accordionReducer from 'core/table-accordion/redux'
import tableReducer from 'core/table/redux'
import toasterReducer from 'core/toaster/redux'
import managementReducer from 'modules/management'
import devicesReducer from 'modules/operational/device'
import NpvrReducer from 'modules/operational/npvr/redux'
import RtfReducer from 'modules/operational/rtf/redux'
import { combineReducers } from 'redux'
import logger from 'redux-logger'
import { thunk } from 'redux-thunk'
import { StateType } from 'typesafe-actions'
import applicationReducer from './applicationReducer'

const rootReducer = combineReducers({
  i18n: I18NReducer,
  accordion: accordionReducer,
  application: applicationReducer,
  pendingTasks: pendingTasksReducer,
  devices: devicesReducer,
  modal: modalReducer,
  spinner: spinnerReducer,
  toasters: toasterReducer,
  navbar: navbarReducer,
  search: searchReducer,
  pagination: paginationReducer,
  management: managementReducer,
  carousel: carouselReducer,
  table: tableReducer,
  sidebar: sidebarReducer,
  multipleSearch: multipleSearchReducer,
  sideMenu: sideMenuReducer,
  rtf: RtfReducer,
  npvr: NpvrReducer,
})

const store = configureStore({
  reducer: rootReducer,

  middleware: () => {
    const middlewares = [thunk]

    if (envs.REACT_APP_DEBUG) {
      middlewares.push(logger)
    }

    return new Tuple(...middlewares)
  },
})

export default store

export type ApplicationState = StateType<typeof rootReducer>

export type Dispatch = typeof store.dispatch